export const ACCOUNT_INFO_PAGE_INIT = 'ACCOUNT_INFO_PAGE/INIT';
export const ACCOUNT_INFO_PAGE_ADD_DOMAIN = 'ACCOUNT_INFO_PAGE/ADD_DOMAIN';
export const ACCOUNT_INFO_PAGE_ADD_DOMAIN_SUCCESS =
  'ACCOUNT_INFO_PAGE/ADD_DOMAIN_SUCCESS';
export const ACCOUNT_INFO_PAGE_ADD_DOMAIN_ERROR =
  'ACCOUNT_INFO_PAGE/ADD_DOMAIN_ERROR';

export const ACCOUNT_INFO_PAGE_REMOVE_DOMAIN =
  'ACCOUNT_INFO_PAGE/REMOVE_DOMAIN';
export const ACCOUNT_INFO_PAGE_REMOVE_DOMAIN_SUCCESS =
  'ACCOUNT_INFO_PAGE/REMOVE_DOMAIN_SUCCESS';
export const ACCOUNT_INFO_PAGE_REMOVE_DOMAIN_ERROR =
  'ACCOUNT_INFO_PAGE/REMOVE_DOMAIN_ERROR';

export const ACCOUNT_INFO_PAGE_UPDATE_USER = 'ACCOUNT_INFO_PAGE/UPDATE_USER';
export const ACCOUNT_INFO_PAGE_UPDATE_USER_SUCCESS =
  'ACCOUNT_INFO_PAGE/UPDATE_USER_SUCCESS';
export const ACCOUNT_INFO_PAGE_UPDATE_USER_ERROR =
  'ACCOUNT_INFO_PAGE/UPDATE_USER_ERROR';
export const ACCOUNT_INFO_RESET = 'ACCOUNT_INFO_PAGE/ACCOUNT_INFO_RESET';

export const EXTEND_TRIAL = 'ACCOUNT_INFO_PAGE/EXTEND_TRIAL';
